exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styled-table .ant-table {\n    background-color: #E5E7EB;\n    border-radius: 10px;\n}\n\np {\n    margin: 0;\n}", ""]);

// exports
